import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    onYes: () => void,
    onNo: () => void
}

const ConfirmDiscardChanges: React.FC<IProps> = (props) => {
    return (
        <Modal show={props.show} backdrop='static' onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>Discard Pending Changes?</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div style={{ marginBottom: 20 }}>Are you sure you want to discard the pending changes for this microsite?</div>
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={props.onYes}>Yes, Discard Changes</Button>
                <Button bsStyle='primary' style={{ marginLeft: 5 }} onClick={props.onNo}>No, Keep Changes</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDiscardChanges;